import React from 'react';
import { CrownIcon, WalletIcon, CarFrontIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Reveal } from './Reveal';
const ITEMS = [{
  icon: CrownIcon,
  title: 'trust.1.title',
  desc: 'trust.1.desc'
}, {
  icon: WalletIcon,
  title: 'trust.2.title',
  desc: 'trust.2.desc'
}, {
  icon: CarFrontIcon,
  title: 'trust.3.title',
  desc: 'trust.3.desc'
}];
export function TrustBar() {
  const {
    t
  } = useLanguage();
  return <section aria-labelledby="trust-heading" className="w-full bg-offwhite" data-id="element-265" data-mp="1qvk24o9osryg">
      <h2 id="trust-heading" className="sr-only" data-id="element-266" data-mp="1uy6z13l7t32i">
        {t('exp.eyebrow')}
      </h2>
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-8 px-4 py-12 sm:px-6 md:grid-cols-3 md:gap-10" data-id="element-267" data-mp="1gyfgcpjr6yi6">
        {ITEMS.map((item, index) => {
        const Icon = item.icon;
        return <Reveal key={item.title} delay={index * 0.08} className="flex items-start gap-4" data-id="element-268" data-mp="5iqpvo7ajhcm" data-mpi={index}>
              <Icon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-camelink" data-id="element-269" data-mp="akpu10auuiam" />
              <div data-id="element-270" data-mp="1ajova6g5nm7l">
                <h3 className="font-display text-sm font-extrabold uppercase tracking-[0.16em] text-ink" data-id="element-271" data-mp="1akzuru2ki7sw">
                  {t(item.title)}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-272" data-mp="1ki4ivzfz4dcc">{t(item.desc)}</p>
              </div>
            </Reveal>;
      })}
      </div>
    </section>;
}